const DEFAULT_TTL_MS = 5000;
const MAX_ENTRIES = 200;

/** @type {Map<string, number>} */
const recent = new Map();

function prune(now) {
  if (recent.size <= MAX_ENTRIES) return;
  for (const [key, ts] of recent) {
    if (now - ts > DEFAULT_TTL_MS) recent.delete(key);
    if (recent.size <= MAX_ENTRIES) break;
  }
}

/**
 * Prevent duplicate bursts (e.g. StrictMode double effects).
 * @param {string} eventName
 * @param {Record<string, unknown>} params
 * @param {number} [ttlMs]
 */
export function shouldSkipDuplicate(eventName, params, ttlMs = DEFAULT_TTL_MS) {
  const stable = JSON.stringify(
    Object.keys(params || {})
      .sort()
      .reduce((acc, k) => {
        acc[k] = params[k];
        return acc;
      }, {})
  );
  const key = `${eventName}:${stable}`;
  const now = Date.now();
  const prev = recent.get(key);
  if (prev != null && now - prev < ttlMs) return true;
  recent.set(key, now);
  prune(now);
  return false;
}

/** Test helper */
export function clearAnalyticsDedupeCache() {
  recent.clear();
}
